<template>
    <div>
        <!-- 面包屑导航 -->
        <el-page-header @back="goBack" content="展位管理"></el-page-header>
        <el-card class="box-card">
            <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                <!-- 展位列表 -->
                <el-tab-pane label="展位列表" name="list">
                    <div style="margin-bottom: 20px;">
                        <el-button type="primary" @click="addNewBooth">新增展位</el-button>
                        <el-button @click="exportBooths">导出数据</el-button>
                    </div>

                    <el-table :data="boothList" border style="width: 100%">
                        <el-table-column prop="id" label="ID" width="60"></el-table-column>
                        <el-table-column prop="name" label="展位名称"  width="80"></el-table-column>
                        <el-table-column label="所属展会"      :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                {{ scope.row.expo_title }}
                            </template>
                        </el-table-column>
                        <el-table-column label="所属场馆"      :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                {{ scope.row.venue_title }}
                            </template>
                        </el-table-column>
                        <el-table-column label="订购商家"      :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                               {{ scope.row.order_shop_title }}
                            </template>
                        </el-table-column>
                        <el-table-column label="订购时间"      :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                              {{ scope.row.order_time|dateFormat }}
                            </template>
                        </el-table-column>
                        <el-table-column label="预定状态"      :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                               <span style="color: #5daf34" v-if="scope.row.order_shop_title">是</span>
                                <span style="color: #FF0000" v-else>否</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="支付信息"      :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <span style="color: #5daf34" v-if="scope.row.order_shop_title">支付信息</span>

                            </template>
                        </el-table-column>
                        <el-table-column label="业务员"      :show-overflow-tooltip='true'>

                        </el-table-column>
                        <el-table-column prop="category_name" label="分类"></el-table-column>
                        <el-table-column prop="type" label="类型" width="100">
                            <template slot-scope="scope">
                                <el-tag :type="scope.row.type === 1 ? 'primary' : 'success'">
                                    {{ scope.row.type === 1 ? '整个展位' : '半个展位' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="price" label="价格" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.price }}元
                            </template>
                        </el-table-column>
                        <el-table-column prop="area" label="面积" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.area }}㎡
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="editBooth(scope.row)">编辑</el-button>
                                <el-button size="mini" type="danger" @click="deleteBooth(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

                <!-- 展位编辑 -->
                <el-tab-pane label="展位编辑" name="edit">
                    <el-form
                            :inline="false"
                            :model="currentBooth"
                            :rules="rules"
                            ref="formRef"
                            label-width="100px"
                            autocomplete="on"
                            size="small"
                    >
                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="展位名称" prop="name">
                                    <el-input placeholder="请输入展位名称" v-model="currentBooth.name" type="text"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="所属展馆" prop="hall_id">
                                    <el-select v-model="currentBooth.hall_id" placeholder="请选择展馆" @change="handleHallChange">
                                        <el-option
                                                v-for="item in hallList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="展位分类" prop="category_id">
                                    <el-select v-model="currentBooth.category_id" placeholder="请选择分类">
                                        <el-option
                                                v-for="item in categoryList"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="24">
                            <el-col :span="8">
                                <el-form-item label="展位类型" prop="type">
                                    <el-radio-group v-model="currentBooth.type">
                                        <el-radio :label="1">整个展位</el-radio>
                                        <el-radio :label="2">半个展位</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="价格(元)" prop="price">
                                    <el-input-number
                                            v-model="currentBooth.price"
                                            :min="0"
                                            :precision="2"
                                            :step="100"
                                            style="width: 100%">
                                    </el-input-number>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="面积(㎡)" prop="area">
                                    <el-input-number
                                            v-model="currentBooth.area"
                                            :min="0"
                                            :precision="2"
                                            :step="1"
                                            style="width: 100%">
                                    </el-input-number>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col>
                                <el-form-item label="展位位置">
                                    <div class="layout-container">
                                        <div class="form-container">
                                            <el-row :gutter="20">
                                                <el-col :span="12">
                                                    <el-form-item label="左上角X">
                                                        <el-input-number
                                                                v-model="currentBooth.top_left_x"
                                                                :min="0"
                                                                :max="1000"
                                                                controls-position="right"
                                                                @change="updatePositionDisplay">
                                                        </el-input-number>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="左上角Y">
                                                        <el-input-number
                                                                v-model="currentBooth.top_left_y"
                                                                :min="0"
                                                                :max="1000"
                                                                controls-position="right"
                                                                @change="updatePositionDisplay">
                                                        </el-input-number>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>

                                            <el-row :gutter="20">
                                                <el-col :span="12">
                                                    <el-form-item label="右上角X">
                                                        <el-input-number
                                                                v-model="currentBooth.top_right_x"
                                                                :min="0"
                                                                :max="1000"
                                                                controls-position="right"
                                                                @change="updatePositionDisplay">
                                                        </el-input-number>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="右上角Y">
                                                        <el-input-number
                                                                v-model="currentBooth.top_right_y"
                                                                :min="0"
                                                                :max="1000"
                                                                controls-position="right"
                                                                @change="updatePositionDisplay">
                                                        </el-input-number>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>

                                            <el-row :gutter="20">
                                                <el-col :span="12">
                                                    <el-form-item label="右下角X">
                                                        <el-input-number
                                                                v-model="currentBooth.bottom_right_x"
                                                                :min="0"
                                                                :max="1000"
                                                                controls-position="right"
                                                                @change="updatePositionDisplay">
                                                        </el-input-number>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="右下角Y">
                                                        <el-input-number
                                                                v-model="currentBooth.bottom_right_y"
                                                                :min="0"
                                                                :max="1000"
                                                                controls-position="right"
                                                                @change="updatePositionDisplay">
                                                        </el-input-number>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>

                                            <el-row :gutter="20">
                                                <el-col :span="12">
                                                    <el-form-item label="左下角X">
                                                        <el-input-number
                                                                v-model="currentBooth.bottom_left_x"
                                                                :min="0"
                                                                :max="1000"
                                                                controls-position="right"
                                                                @change="updatePositionDisplay">
                                                        </el-input-number>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item label="左下角Y">
                                                        <el-input-number
                                                                v-model="currentBooth.bottom_left_y"
                                                                :min="0"
                                                                :max="1000"
                                                                controls-position="right"
                                                                @change="updatePositionDisplay">
                                                        </el-input-number>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>

                                            <div style="margin-top: 10px;">
                                                <el-button type="primary" size="small" @click="startPointSelection">
                                                    {{ isSelectingPoints ? '结束选点' : '开始选点' }}
                                                </el-button>
                                                <el-button size="small" @click="clearCoordinates">清空坐标</el-button>
                                                <el-button size="small" @click="autoDetectBooths">自动识别展位</el-button>
                                                <el-upload
                                                        action="#"
                                                        :show-file-list="false"
                                                        :before-upload="beforeMapUpload"
                                                        :on-change="handleMapUpload"
                                                        :auto-upload="false"
                                                        accept=".png,.jpg,.jpeg,.webp,.svg"
                                                        style="display: inline-block; margin-left: 10px;">
                                                    <el-button size="small">上传地图</el-button>
                                                </el-upload>
                                            </div>
                                        </div>


                                    </div>
                                    <div class="map-container">
                                        <div class="map-header">
                                            <span class="map-title">展馆布局图</span>
                                            <div class="map-controls">
                                                <el-button
                                                        size="mini"
                                                        @click="zoomOut"
                                                        :disabled="isLocked">
                                                    缩小
                                                </el-button>
                                                <el-button
                                                        size="mini"
                                                        @click="zoomIn"
                                                        :disabled="isLocked">
                                                    放大
                                                </el-button>
                                                <el-button
                                                        size="mini"
                                                        @click="resetView">
                                                    重置视图
                                                </el-button>
                                                <el-button
                                                        size="mini"
                                                        :type="isLocked ? 'success' : ''"
                                                        @click="toggleLock">
                                                    {{ isLocked ? '已锁定' : '锁定视图' }}
                                                </el-button>
                                                <span class="zoom-display">缩放: {{ Math.round(scale * 100) }}%</span>
                                            </div>
                                        </div>
                                        <div
                                                class="map-canvas"
                                                ref="mapCanvas"
                                                @click="handleMapClick"
                                                @mousemove="handleMouseMove"
                                                @mousedown="handleMouseDown">
                                            <canvas ref="canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
                                        </div>

                                        <div class="coordinates-display">
                                            <div class="coordinate-item">
                                                <span>鼠标位置: </span>
                                                <span v-if="mousePosition">({{ mousePosition.x }}, {{ mousePosition.y }})</span>
                                                <span v-else>未检测</span>
                                            </div>
                                            <div class="coordinate-item">
                                                <span>选择状态: </span>
                                                <el-tag :type="isSelectingPoints ? 'success' : 'info'" size="small">
                                                    {{ isSelectingPoints ? '选点中' : '浏览中' }}
                                                </el-tag>
                                            </div>
                                            <div class="coordinate-item">
                                                <span>视图状态: </span>
                                                <el-tag :type="isLocked ? 'success' : 'warning'" size="small">
                                                    {{ isLocked ? '已锁定' : '可缩放' }}
                                                </el-tag>
                                            </div>
                                            <div class="coordinate-item" v-if="selectedPoints.length > 0">
                                                <span>已选点: </span>
                                                <el-tag
                                                        v-for="(point, index) in selectedPoints"
                                                        :key="index"
                                                        size="small"
                                                        style="margin-right: 5px;">
                                                    点{{ index + 1 }}({{ point.x }}, {{ point.y }})
                                                </el-tag>
                                            </div>
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col>
                                <el-form-item label="展位图片">
                                    <el-upload
                                            class="upload-demo"
                                            action="#"
                                            :on-change="handleImageUpload"
                                            :auto-upload="false"
                                            :show-file-list="false">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                                    </el-upload>
                                    <div v-if="currentBooth.image_url" style="margin-top: 10px;">
                                        <el-image
                                                :src="currentBooth.image_url"
                                                style="max-width: 200px; max-height: 150px;">
                                        </el-image>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col>
                                <el-form-item label="展位描述">
                                    <el-input
                                            type="textarea"
                                            :rows="4"
                                            placeholder="请输入展位描述"
                                            v-model="currentBooth.description">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col>
                                <el-form-item>
                                    <el-button type="primary" @click="submitForm">保存</el-button>
                                    <el-button @click="resetForm">重置</el-button>
                                    <el-button @click="activeTab = 'list'">返回列表</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </el-card>

        <!-- 展位信息提示框 -->
        <el-dialog
                :title="selectedBoothInfo ? selectedBoothInfo.name : '展位信息'"
                :visible.sync="showBoothInfoDialog"
                width="500px"
                :before-close="closeBoothInfoDialog">
            <div v-if="selectedBoothInfo" class="booth-info-content">
                <el-descriptions :column="2" border>
                    <el-descriptions-item label="展位名称">{{ selectedBoothInfo.name }}</el-descriptions-item>
                    <el-descriptions-item label="所属展馆">{{ selectedBoothInfo.hall_name }}</el-descriptions-item>
                    <el-descriptions-item label="分类">{{ selectedBoothInfo.category_name }}</el-descriptions-item>
                    <el-descriptions-item label="类型">
                        <el-tag :type="selectedBoothInfo.type === 1 ? 'primary' : 'success'">
                            {{ selectedBoothInfo.type === 1 ? '整个展位' : '半个展位' }}
                        </el-tag>
                    </el-descriptions-item>
                    <el-descriptions-item label="价格">{{ selectedBoothInfo.price }}元</el-descriptions-item>
                    <el-descriptions-item label="面积">{{ selectedBoothInfo.area }}㎡</el-descriptions-item>
                    <el-descriptions-item label="描述" :span="2">
                        {{ selectedBoothInfo.description || '暂无描述' }}
                    </el-descriptions-item>
                </el-descriptions>

                <!-- 坐标信息 -->
                <div class="coordinate-info" style="margin-top: 15px;">
                    <h4>坐标信息：</h4>
                    <div class="coordinate-grid">
                        <div class="coordinate-item">左上角: ({{ selectedBoothInfo.top_left_x }}, {{ selectedBoothInfo.top_left_y }})</div>
                        <div class="coordinate-item">右上角: ({{ selectedBoothInfo.top_right_x }}, {{ selectedBoothInfo.top_right_y }})</div>
                        <div class="coordinate-item">右下角: ({{ selectedBoothInfo.bottom_right_x }}, {{ selectedBoothInfo.bottom_right_y }})</div>
                        <div class="coordinate-item">左下角: ({{ selectedBoothInfo.bottom_left_x }}, {{ selectedBoothInfo.bottom_left_y }})</div>
                    </div>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="closeBoothInfoDialog">关闭</el-button>
                <el-button type="primary" @click="editSelectedBooth" v-if="selectedBoothInfo">编辑此展位</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    // 导入 seat_map.webp 图片
    import seatMap from '@/assets/upload/seat_map.webp';
    import moment from "moment";

    export default {
        data() {
            return {
                scheduleData:null,
                schedule_id:'',
                activeTab: 'list',
                currentBooth: {
                    id: '',
                    name: '',
                    hall_id: '',
                    category_id: '',
                    type: 1,
                    price: 0,
                    area: 0,
                    top_left_x: 0,
                    top_left_y: 0,
                    top_right_x: 0,
                    top_right_y: 0,
                    bottom_right_x: 0,
                    bottom_right_y: 0,
                    bottom_left_x: 0,
                    bottom_left_y: 0,
                    image_url: '',
                    description: ''
                },
                rules: {
                    name: [
                        {required: true, message: '请输入展位名称', trigger: 'blur'}
                    ],
                    hall_id: [
                        {required: true, message: '请选择展馆', trigger: 'change'}
                    ],
                    category_id: [
                        {required: true, message: '请选择分类', trigger: 'change'}
                    ],
                    price: [
                        {required: true, message: '请输入价格', trigger: 'blur'}
                    ],
                    area: [
                        {required: true, message: '请输入面积', trigger: 'blur'}
                    ]
                },
                hallList: [
                    {id: 1, name: 'A展馆', map_url: seatMap},
                    {id: 2, name: 'B展馆', map_url: seatMap},
                    {id: 3, name: 'C展馆', map_url: seatMap}
                ],
                categoryList: [
                    {id: 1, name: '标准展位'},
                    {id: 2, name: '特装展位'},
                    {id: 3, name: '室外展位'}
                ],
                boothList: [],
                isSelectingPoints: false,
                selectedPoints: [],
                mousePosition: null,
                canvas: null,
                ctx: null,
                backgroundImage: null,
                canvasWidth: 800,
                canvasHeight: 600,
                scale: 1,
                offsetX: 0,
                offsetY: 0,
                isDragging: false,
                lastMouseX: 0,
                lastMouseY: 0,
                // 用于存储所有已保存展位的DOM元素，便于清理
                savedBoothElements: [],
                // 锁定状态
                isLocked: false,
                // 新增：展位信息对话框相关
                showBoothInfoDialog: false,
                selectedBoothInfo: null,
                // 新增：高亮选中的展位
                highlightedBooth: null
            }
        },
        filters: {
            // 时间格式化
            dateFormat(add_time) {
                if (!add_time) return "";
                return moment(add_time * 1000).format("YYYY-MM-DD HH:mm");
            }
        },
        created() {
            this.schedule_id = this.$route.query.id;
            if (this.schedule_id) {
                this.getScheduleDetail();
            } else {
                this.$message.error('展会排期ID不存在');
                this.goBack();
            }
        },
        mounted() {

            this.initCanvas();
            this.loadBooths();
            this.$nextTick(() => {
                this.loadHallMap();
            });
        },
        beforeDestroy() {
            // 清理事件监听器
            if (this.$refs.mapCanvas) {
                this.$refs.mapCanvas.removeEventListener('wheel', this.handleWheel);
            }
            document.removeEventListener('mousemove', this.handleMouseMove);
            document.removeEventListener('mouseup', this.handleMouseUp);
        },
        methods: {
            getScheduleDetail() {
                const param = {
                    company_id: sessionStorage.getItem('company_id'),
                    access_token: sessionStorage.getItem('token'),
                    id: this.schedule_id
                }
                this.$axios.findExpoScheduleOne(param).then(res => {
                    if (res.code == 200) {
                        this.scheduleData = res.data || {};
                    }
                }).catch(error => {
                    console.log(error);
                })
            },
            initCanvas() {
                this.canvas = this.$refs.canvas;
                this.ctx = this.canvas.getContext('2d');

                // 添加鼠标滚轮缩放支持
                if (this.$refs.mapCanvas) {
                    this.$refs.mapCanvas.addEventListener('wheel', this.handleWheel, { passive: false });
                }

                // 添加鼠标拖拽支持
                document.addEventListener('mousemove', this.handleMouseMove);
                document.addEventListener('mouseup', this.handleMouseUp);
            },

            getDefaultMapImage() {
                // 返回一个简单的Base64网格图片作为备用
                return 'data:image/svg+xml;base64,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';
            },

            async loadHallMap() {
                try {
                    const hall = this.hallList.find(h => h.id === this.currentBooth.hall_id) || this.hallList[0];
                    if (hall && hall.map_url) {
                        await this.loadImage(hall.map_url);
                    } else {
                        this.drawGridBackground();
                    }
                } catch (error) {
                    console.error('加载地图失败:', error);
                    this.drawGridBackground();
                }
            },

            loadImage(src) {
                return new Promise((resolve, reject) => {
                    const img = new Image();

                    // 设置超时时间
                    const timeout = setTimeout(() => {
                        reject(new Error('图片加载超时'));
                    }, 5000);

                    img.onload = () => {
                        clearTimeout(timeout);
                        console.log('图片加载成功');
                        this.backgroundImage = img;
                        this.adjustCanvasSize();
                        this.drawMap();
                        // 绘制所有已保存的展位
                        this.drawAllSavedBooths();
                        resolve();
                    };

                    img.onerror = (error) => {
                        clearTimeout(timeout);
                        console.error('图片加载失败:', error);
                        // 如果导入的图片加载失败，使用默认网格图
                        this.loadDefaultImage();
                        reject(error);
                    };

                    img.src = src;

                    // 如果图片已经在缓存中
                    if (img.complete) {
                        img.onload();
                    }
                });
            },

            loadDefaultImage() {
                const defaultImg = new Image();
                defaultImg.onload = () => {
                    this.backgroundImage = defaultImg;
                    this.drawMap();
                    // 绘制所有已保存的展位
                    this.drawAllSavedBooths();
                };
                defaultImg.src = this.getDefaultMapImage();
            },

            adjustCanvasSize() {
                if (this.backgroundImage && this.backgroundImage.width) {
                    // 根据图片尺寸调整画布，但限制最大尺寸
                    const maxWidth = 800;
                    const maxHeight = 600;

                    let width = this.backgroundImage.width;
                    let height = this.backgroundImage.height;

                    // 如果图片太大，按比例缩放
                    if (width > maxWidth || height > maxHeight) {
                        const ratio = Math.min(maxWidth / width, maxHeight / height);
                        width = width * ratio;
                        height = height * ratio;
                    }

                    this.canvasWidth = Math.floor(width);
                    this.canvasHeight = Math.floor(height);

                    // 重新设置canvas尺寸
                    this.canvas.width = this.canvasWidth;
                    this.canvas.height = this.canvasHeight;
                }
            },


            drawAllSavedBooths() {
                // 清除之前保存的展位元素
                this.clearSavedBooths();

                // 绘制所有已保存的展位
                this.boothList.forEach(booth => {
                    this.drawSavedBooth(booth);
                });
            },

            drawSavedBooth(booth) {
                // 创建展位覆盖层
                const polygon = document.createElement('div');
                polygon.className = 'saved-booth-polygon';

                // 设置基本样式
                polygon.style.position = 'absolute';
                polygon.style.border = '2px solid #409eff';
                polygon.style.backgroundColor = 'rgba(64, 158, 255, 0.2)';
                polygon.style.zIndex = '10';

                // 计算多边形的边界
                const points = [
                    {x: booth.top_left_x, y: booth.top_left_y},
                    {x: booth.top_right_x, y: booth.top_right_y},
                    {x: booth.bottom_right_x, y: booth.bottom_right_y},
                    {x: booth.bottom_left_x, y: booth.bottom_left_y}
                ];

                const minX = Math.min(...points.map(p => p.x));
                const minY = Math.min(...points.map(p => p.y));
                const maxX = Math.max(...points.map(p => p.x));
                const maxY = Math.max(...points.map(p => p.y));

                // 关键修改：使用绝对坐标而不是相对坐标
                // 设置位置和大小
                polygon.style.left = (minX * this.scale + this.offsetX) + 'px';
                polygon.style.top = (minY * this.scale + this.offsetY) + 'px';
                polygon.style.width = (maxX - minX) * this.scale + 'px';
                polygon.style.height = (maxY - minY) * this.scale + 'px';

                // 使用clip-path创建多边形形状，使用绝对坐标
                const clipPath = `polygon(
                    ${((booth.top_left_x - minX) * this.scale)}px ${((booth.top_left_y - minY) * this.scale)}px,
                    ${((booth.top_right_x - minX) * this.scale)}px ${((booth.top_right_y - minY) * this.scale)}px,
                    ${((booth.bottom_right_x - minX) * this.scale)}px ${((booth.bottom_right_y - minY) * this.scale)}px,
                    ${((booth.bottom_left_x - minX) * this.scale)}px ${((booth.bottom_left_y - minY) * this.scale)}px
                )`;
                polygon.style.clipPath = clipPath;
                polygon.style.webkitClipPath = clipPath;

                // 添加展位名称标签
                const label = document.createElement('div');
                label.className = 'booth-label';
                label.textContent = booth.name;
                label.style.position = 'absolute';
                label.style.left = '50%';
                label.style.top = '50%';
                label.style.transform = 'translate(-50%, -50%)';
                label.style.background = 'rgba(255, 107, 107, 0.8)';
                label.style.padding = '2px 6px';
                label.style.borderRadius = '2px';
                label.style.fontSize = '12px';
                label.style.fontWeight = 'bold';
                label.style.zIndex = '11';

                polygon.appendChild(label);

                // 添加到画布容器
                this.$refs.mapCanvas.appendChild(polygon);

                // 保存引用
                this.savedBoothElements.push(polygon);
            },

            clearSavedBooths() {
                // 清除所有已保存的展位元素
                this.savedBoothElements.forEach(element => {
                    if (element && element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                });
                this.savedBoothElements = [];
            },

            drawSelectedPoints() {
                const ctx = this.ctx;
                this.selectedPoints.forEach((point, index) => {
                    ctx.save();

                    ctx.translate(this.offsetX, this.offsetY);
                    ctx.scale(this.scale, this.scale);

                    // 绘制点
                    ctx.fillStyle = '#f56c6c';
                    ctx.beginPath();
                    ctx.arc(point.x, point.y, 5 / this.scale, 0, Math.PI * 2);
                    ctx.fill();

                    // 绘制序号
                    ctx.fillStyle = '#fff';
                    ctx.font = `${10 / this.scale}px Arial`;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText((index + 1).toString(), point.x, point.y);

                    ctx.restore();
                });
            },

            drawGridBackground() {
                const ctx = this.ctx;
                const width = this.canvas.width;
                const height = this.canvas.height;

                ctx.clearRect(0, 0, width, height);
                ctx.fillStyle = '#f9f9f9';
                ctx.fillRect(0, 0, width, height);

                ctx.strokeStyle = '#e0e0e0';
                ctx.lineWidth = 0.5;

                for (let x = 0; x <= width; x += 20) {
                    ctx.beginPath();
                    ctx.moveTo(x, 0);
                    ctx.lineTo(x, height);
                    ctx.stroke();
                }

                for (let y = 0; y <= height; y += 20) {
                    ctx.beginPath();
                    ctx.moveTo(0, y);
                    ctx.lineTo(width, y);
                    ctx.stroke();
                }

                // 绘制坐标轴
                ctx.strokeStyle = '#999';
                ctx.lineWidth = 1;
                ctx.beginPath();
                ctx.moveTo(0, 0);
                ctx.lineTo(width, 0);
                ctx.moveTo(0, 0);
                ctx.lineTo(0, height);
                ctx.stroke();

                // 绘制坐标刻度
                ctx.fillStyle = '#666';
                ctx.font = '10px Arial';
                for (let x = 50; x <= width; x += 50) {
                    ctx.fillText(x, x, 10);
                }
                for (let y = 50; y <= height; y += 50) {
                    ctx.fillText(y, 5, y);
                }
            },
            handleMapClick(event) {
                // 转换点击坐标到画布坐标系
                const rect = this.canvas.getBoundingClientRect();
                const x = (event.clientX - rect.left - this.offsetX) / this.scale;
                const y = (event.clientY - rect.top - this.offsetY) / this.scale;

                const clickPoint = { x: Math.round(x), y: Math.round(y) };

                if (this.isSelectingPoints) {
                    // 原有的选点逻辑
                    this.selectedPoints.push(clickPoint);

                    // 自动设置四个点的坐标
                    if (this.selectedPoints.length === 4) {
                        this.setBoothCoordinates();
                        this.isSelectingPoints = false;
                        this.$message.success('已选择四个点，坐标已自动填充');
                    }

                    this.drawMap();
                } else {
                    // 新增：检查点击是否在某个展位区域内
                    this.checkBoothClick(clickPoint);
                }
            },

            handleMouseDown(event) {
                if (event.button === 0) { // 左键
                    this.isDragging = true;
                    this.lastMouseX = event.clientX;
                    this.lastMouseY = event.clientY;
                    event.preventDefault();
                }
            },

            handleMouseMove(event) {
                const rect = this.canvas.getBoundingClientRect();
                const x = (event.clientX - rect.left - this.offsetX) / this.scale;
                const y = (event.clientY - rect.top - this.offsetY) / this.scale;

                this.mousePosition = { x: Math.round(x), y: Math.round(y) };

                if (this.isDragging) {
                    this.offsetX += event.clientX - this.lastMouseX;
                    this.offsetY += event.clientY - this.lastMouseY;
                    this.lastMouseX = event.clientX;
                    this.lastMouseY = event.clientY;
                    this.drawMap();
                    // 更新已保存展位的位置
                    this.updateSavedBoothsPosition();
                }
            },

            handleMouseUp(event) {
                if (event.button === 0) {
                    this.isDragging = false;
                }
            },

            handleWheel(event) {
                // 如果锁定状态，阻止缩放
                if (this.isLocked) {
                    event.preventDefault();
                    return;
                }

                event.preventDefault();

                if (!this.$refs.mapCanvas) return;

                const rect = this.canvas.getBoundingClientRect();
                const mouseX = event.clientX - rect.left;
                const mouseY = event.clientY - rect.top;

                const zoomIntensity = 0.1;
                const wheel = event.deltaY < 0 ? 1 : -1;
                const zoom = Math.exp(wheel * zoomIntensity);

                // 应用缩放
                const newScale = this.scale * zoom;
                this.scale = Math.max(0.1, Math.min(5, newScale)); // 限制缩放范围

                // 调整偏移以在鼠标位置缩放
                this.offsetX -= (mouseX - this.offsetX) * (zoom - 1);
                this.offsetY -= (mouseY - this.offsetY) * (zoom - 1);

                this.drawMap();
                // 更新已保存展位的位置和大小
                this.updateSavedBoothsPosition();
            },


            // 新增：检查点击是否在展位区域内
            checkBoothClick(clickPoint) {
                // 遍历所有展位，检查点击点是否在展位多边形内
                for (let i = this.boothList.length - 1; i >= 0; i--) {
                    const booth = this.boothList[i];
                    if (this.isPointInPolygon(clickPoint, this.getBoothPolygon(booth))) {
                        // 点击在展位内，显示展位信息
                        this.showBoothInfo(booth);
                        return;
                    }
                }

                // 如果没有点击到任何展位，隐藏之前的高亮
                this.clearBoothHighlight();
            },

            // 新增：判断点是否在多边形内（使用射线法）
            isPointInPolygon(point, polygon) {
                const x = point.x, y = point.y;
                let inside = false;

                for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
                    const xi = polygon[i].x, yi = polygon[i].y;
                    const xj = polygon[j].x, yj = polygon[j].y;

                    const intersect = ((yi > y) !== (yj > y)) &&
                        (x < (xj - xi) * (y - yi) / (yj - yi) + xi);

                    if (intersect) inside = !inside;
                }

                return inside;
            },

            // 新增：获取展位的多边形坐标
            getBoothPolygon(booth) {
                return [
                    { x: booth.top_left_x, y: booth.top_left_y },
                    { x: booth.top_right_x, y: booth.top_right_y },
                    { x: booth.bottom_right_x, y: booth.bottom_right_y },
                    { x: booth.bottom_left_x, y: booth.bottom_left_y }
                ];
            },

            // 新增：显示展位信息
            showBoothInfo(booth) {
                this.selectedBoothInfo = booth;
                this.showBoothInfoDialog = true;

                // 高亮显示选中的展位
                this.highlightBooth(booth);
            },

            // 新增：高亮显示展位
            highlightBooth(booth) {
                this.clearBoothHighlight();

                // 创建高亮覆盖层
                const highlight = document.createElement('div');
                highlight.className = 'booth-highlight';
                highlight.dataset.boothId = booth.id;

                // 设置高亮样式
                highlight.style.position = 'absolute';
                highlight.style.border = '3px solid #ff6b6b';
                highlight.style.backgroundColor = 'rgba(255, 107, 107, 0.3)';
                highlight.style.zIndex = '20';
                highlight.style.pointerEvents = 'none';

                // 计算多边形的边界
                const points = this.getBoothPolygon(booth);
                const minX = Math.min(...points.map(p => p.x));
                const minY = Math.min(...points.map(p => p.y));
                const maxX = Math.max(...points.map(p => p.x));
                const maxY = Math.max(...points.map(p => p.y));

                // 设置位置和大小
                highlight.style.left = (minX * this.scale + this.offsetX) + 'px';
                highlight.style.top = (minY * this.scale + this.offsetY) + 'px';
                highlight.style.width = (maxX - minX) * this.scale + 'px';
                highlight.style.height = (maxY - minY) * this.scale + 'px';

                // 使用clip-path创建多边形形状
                const clipPath = `polygon(
                    ${((booth.top_left_x - minX) * this.scale)}px ${((booth.top_left_y - minY) * this.scale)}px,
                    ${((booth.top_right_x - minX) * this.scale)}px ${((booth.top_right_y - minY) * this.scale)}px,
                    ${((booth.bottom_right_x - minX) * this.scale)}px ${((booth.bottom_right_y - minY) * this.scale)}px,
                    ${((booth.bottom_left_x - minX) * this.scale)}px ${((booth.bottom_left_y - minY) * this.scale)}px
                )`;
                highlight.style.clipPath = clipPath;
                highlight.style.webkitClipPath = clipPath;

                // 添加到画布容器
                this.$refs.mapCanvas.appendChild(highlight);

                // 保存引用
                this.highlightedBooth = highlight;
            },

            // 新增：清除展位高亮
            clearBoothHighlight() {
                if (this.highlightedBooth && this.highlightedBooth.parentNode) {
                    this.highlightedBooth.parentNode.removeChild(this.highlightedBooth);
                    this.highlightedBooth = null;
                }
            },

            // 新增：关闭展位信息对话框
            closeBoothInfoDialog() {
                this.showBoothInfoDialog = false;
                this.selectedBoothInfo = null;
                this.clearBoothHighlight();
            },

            // 新增：编辑选中的展位
            editSelectedBooth() {
                if (this.selectedBoothInfo) {
                    this.editBooth(this.selectedBoothInfo);
                    this.closeBoothInfoDialog();
                }
            },

            // 修改：在绘制地图时也要考虑高亮
            drawMap() {
                if (!this.ctx) return;

                const ctx = this.ctx;
                const width = this.canvas.width;
                const height = this.canvas.height;

                // 清除画布
                ctx.clearRect(0, 0, width, height);

                // 绘制背景色
                ctx.fillStyle = '#f9f9f9';
                ctx.fillRect(0, 0, width, height);

                // 保存当前状态
                ctx.save();

                // 应用变换
                ctx.translate(this.offsetX, this.offsetY);
                ctx.scale(this.scale, this.scale);

                // 绘制背景图片或网格
                if (this.backgroundImage && this.backgroundImage.width > 0) {
                    try {
                        ctx.drawImage(this.backgroundImage, 0, 0);
                    } catch (error) {
                        console.error('绘制图片失败:', error);
                        this.drawGridBackground();
                    }
                } else {
                    this.drawGridBackground();
                }

                // 恢复状态
                ctx.restore();

                // 绘制当前选中的点
                this.drawSelectedPoints();
            },

            // 修改：在更新已保存展位位置时也要更新高亮
            updateSavedBoothsPosition() {
                // 重新绘制所有已保存的展位
                this.drawAllSavedBooths();

                // 如果有高亮的展位，重新高亮
                if (this.selectedBoothInfo) {
                    this.highlightBooth(this.selectedBoothInfo);
                }
            },

            setBoothCoordinates() {
                if (this.selectedPoints.length === 4) {
                    // 简单排序：找到左上、右上、右下、左下
                    const sortedPoints = this.selectedPoints.sort((a, b) => {
                        if (a.y === b.y) return a.x - b.x;
                        return a.y - b.y;
                    });

                    const topPoints = sortedPoints.slice(0, 2).sort((a, b) => a.x - b.x);
                    const bottomPoints = sortedPoints.slice(2, 4).sort((a, b) => a.x - b.x);

                    this.currentBooth.top_left_x = topPoints[0].x;
                    this.currentBooth.top_left_y = topPoints[0].y;
                    this.currentBooth.top_right_x = topPoints[1].x;
                    this.currentBooth.top_right_y = topPoints[1].y;
                    this.currentBooth.bottom_right_x = bottomPoints[1].x;
                    this.currentBooth.bottom_right_y = bottomPoints[1].y;
                    this.currentBooth.bottom_left_x = bottomPoints[0].x;
                    this.currentBooth.bottom_left_y = bottomPoints[0].y;
                }
            },

            startPointSelection() {
                this.isSelectingPoints = !this.isSelectingPoints;
                this.selectedPoints = [];
                if (this.isSelectingPoints) {
                    this.$message.info('请在图上点击选择四个角点');
                } else {
                    this.$message.info('已退出选点模式');
                }
            },

            clearCoordinates() {
                this.selectedPoints = [];
                this.currentBooth.top_left_x = 0;
                this.currentBooth.top_left_y = 0;
                this.currentBooth.top_right_x = 0;
                this.currentBooth.top_right_y = 0;
                this.currentBooth.bottom_right_x = 0;
                this.currentBooth.bottom_right_y = 0;
                this.currentBooth.bottom_left_x = 0;
                this.currentBooth.bottom_left_y = 0;
                this.drawMap();
                this.$message.info('已清空坐标');
            },

            updatePositionDisplay() {
                this.drawMap();
            },

            zoomIn() {
                // 如果锁定状态，阻止缩放
                if (this.isLocked) {
                    this.$message.warning('视图已锁定，无法缩放');
                    return;
                }

                this.scale *= 1.2;
                this.scale = Math.min(5, this.scale);
                this.drawMap();
                this.updateSavedBoothsPosition();
            },

            zoomOut() {
                // 如果锁定状态，阻止缩放
                if (this.isLocked) {
                    this.$message.warning('视图已锁定，无法缩放');
                    return;
                }

                this.scale /= 1.2;
                this.scale = Math.max(0.1, this.scale);
                this.drawMap();
                this.updateSavedBoothsPosition();
            },

            resetView() {
                this.scale = 1;
                this.offsetX = 0;
                this.offsetY = 0;
                this.drawMap();
                this.updateSavedBoothsPosition();
                this.$message.success('视图已重置');
            },

            // 切换锁定状态
            toggleLock() {
                this.isLocked = !this.isLocked;
                if (this.isLocked) {
                    this.$message.success('视图已锁定，可拖拽但无法缩放');
                } else {
                    this.$message.info('视图已解锁，可缩放和拖拽');
                }
            },

            autoDetectBooths() {
                this.$message.info('自动识别功能开发中...');
                // 这里可以集成计算机视觉算法来自动识别图片中的展位
            },

            beforeMapUpload(file) {
                const isImage = /\.(png|jpg|jpeg|webp|svg)$/i.test(file.name);
                const isLt5M = file.size / 1024 / 1024 < 5;

                if (!isImage) {
                    this.$message.error('只能上传图片文件!');
                    return false;
                }
                if (!isLt5M) {
                    this.$message.error('图片大小不能超过 5MB!');
                    return false;
                }
                return true;
            },

            handleMapUpload(file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.backgroundImage = new Image();
                    this.backgroundImage.onload = () => {
                        this.adjustCanvasSize();
                        this.drawMap();
                        this.drawAllSavedBooths();
                        this.$message.success('地图上传成功');
                    };
                    this.backgroundImage.onerror = () => {
                        this.$message.error('图片加载失败');
                        this.drawGridBackground();
                    };
                    this.backgroundImage.src = e.target.result;
                };
                reader.readAsDataURL(file.raw);
            },

            handleHallChange(hallId) {
                console.log(hallId)
                this.loadHallMap();
            },

            handleImageUpload(file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.currentBooth.image_url = e.target.result;
                };
                reader.readAsDataURL(file.raw);
            },
            loadBooths() {
                this.boothList=[];
                const params1 = {
                    access_token: sessionStorage.getItem('token'),
                    company_id: sessionStorage.getItem('company_id')
                }
                this.$axios.findBoothList(params1).then(res => {
                    if (res.code == 200) {
                        res.data.forEach((item) => {
                            let it = {
                                id: item.id,
                                name: item.sn,
                                expo_title:item.expo?item.expo.title:'',
                                venue_title:item.venue?item.venue.title:'',
                                order_shop_title:item.ordershop?item.ordershop.name:'',
                                order_time:item.order_time,
                                hall_id: 1,
                                hall_name: 'A展馆',
                                category_id: 1,
                                category_name: '标准展位',
                                type: item.type,
                                price: 5000,
                                area: item.area,
                                top_left_x: item.x1,
                                top_left_y: item.y1,
                                top_right_x: item.x2,
                                top_right_y: item.y2,
                                bottom_right_x: item.x3,
                                bottom_right_y: item.y3,
                                bottom_left_x: item.x4,
                                bottom_left_y: item.y4,
                                image_url: '',
                                description: '位于A展馆入口处的标准展位'
                            };
                            this.boothList.push(it)
                        })
                    }
                })
            },

            addNewBooth() {
                this.currentBooth = {
                    id: '',
                    name: '',
                    hall_id: this.hallList[0].id,
                    category_id: this.categoryList[0].id,
                    type: 1,
                    price: 0,
                    area: 0,
                    top_left_x: 0,
                    top_left_y: 0,
                    top_right_x: 0,
                    top_right_y: 0,
                    bottom_right_x: 0,
                    bottom_right_y: 0,
                    bottom_left_x: 0,
                    bottom_left_y: 0,
                    image_url: '',
                    description: ''
                };
                this.selectedPoints = [];
                this.activeTab = 'edit';
                this.loadHallMap();
            },

            editBooth(booth) {
                this.currentBooth = {...booth};
                this.activeTab = 'edit';
                this.loadHallMap();
            },

            deleteBooth(id) {
                this.$confirm('确定要删除这个展位吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.boothList = this.boothList.filter(booth => booth.id !== id);
                    // 重新绘制已保存的展位
                    this.drawAllSavedBooths();
                    this.$message.success('删除成功');
                });
            },

            submitForm() {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        if (!this.validateCoordinates()) {
                            this.$message.error('请设置完整的展位坐标');
                            return;
                        }

                        if (this.currentBooth.id) {
                            // 更新现有展位
                            const index = this.boothList.findIndex(b => b.id === this.currentBooth.id);
                            if (index !== -1) {
                                this.boothList[index] = {...this.currentBooth};
                            }
                        } else {
                            // 新增展位
                            this.currentBooth.id = Date.now();
                            this.currentBooth.hall_name = this.hallList.find(h => h.id === this.currentBooth.hall_id)?.name || '';
                            this.currentBooth.category_name = this.categoryList.find(c => c.id === this.currentBooth.category_id)?.name || '';
                            this.boothList.push({...this.currentBooth});
                        }



                        this.$message.success('保存成功');
                        const params = {
                            access_token:sessionStorage.getItem('token'),
                            company_id:sessionStorage.getItem('company_id'),
                            ...this.currentBooth
                        }
                        console.log('save params',params)
                        this.$axios.boothSave(params).then(res=>{
                            console.log(res)
                            if(res.code==200){

                                console.log(res)
                            }

                        })




                        // 重新绘制所有已保存的展位
                        this.drawAllSavedBooths();


                        //this.activeTab = 'list';
                    }
                });
            },

            validateCoordinates() {
                return this.currentBooth.top_left_x > 0 && this.currentBooth.top_left_y > 0 &&
                    this.currentBooth.top_right_x > 0 && this.currentBooth.top_right_y > 0 &&
                    this.currentBooth.bottom_right_x > 0 && this.currentBooth.bottom_right_y > 0 &&
                    this.currentBooth.bottom_left_x > 0 && this.currentBooth.bottom_left_y > 0;
            },

            resetForm() {
                this.$refs.formRef.resetFields();
                this.clearCoordinates();
            },

            exportBooths() {
                // 导出展位数据
                const dataStr = JSON.stringify(this.boothList, null, 2);
                const dataBlob = new Blob([dataStr], {type: 'application/json'});
                const url = URL.createObjectURL(dataBlob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'booths_export.json';
                link.click();
                URL.revokeObjectURL(url);
            },

            handleTabClick(tab) {
                if (tab.name === 'list') {

                    this.loadBooths();
                }
            },

            goBack() {
                console.log('返回上一页');
            }
        }
    }
</script>

<style scoped>
    .layout-container {
        display: flex;
        gap: 20px;
    }
    .form-container {
        flex: 1;
        max-width: 400px;
    }
    .map-container {
        flex: 2;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        padding: 15px;
        background-color: #f5f7fa;
        position: relative;
    }
    .map-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
    }
    .map-title {
        font-size: 16px;
        font-weight: bold;
    }
    .map-canvas {
        width: 100%;
        height: 400px;
        background-color: #fff;
        border: 1px solid #dcdfe6;
        position: relative;
        cursor: crosshair;
        overflow: hidden;
    }
    .coordinates-display {
        margin-top: 15px;
        padding: 10px;
        background-color: #f0f9ff;
        border-radius: 4px;
    }
    .coordinate-item {
        margin-bottom: 5px;
    }
    .map-controls {
        display: flex;
        gap: 5px;
        align-items: center;
    }
    .zoom-display {
        margin-left: 10px;
        padding: 4px 8px;
        background: rgba(64, 158, 255, 0.1);
        border-radius: 4px;
        font-size: 12px;
        color: #409eff;
        font-weight: bold;
    }

    /* 已保存展位的样式 */
    .saved-booth-polygon {
        pointer-events: none; /* 允许点击穿透到下层canvas */
    }

    .booth-label {
        pointer-events: none;
    }

    /* 新增：展位信息对话框样式 */
    .booth-info-content {
        padding: 10px 0;
    }

    .coordinate-info {
        background-color: #f8f9fa;
        padding: 10px;
        border-radius: 4px;
    }

    .coordinate-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        margin-top: 8px;
    }

    .coordinate-item {
        font-size: 12px;
        color: #666;
    }
</style>
